<template>
  <div class="slider-controller" ref="slider" @mousedown.p.passive="sliderDown">
    <input type="range" :min="minValue" :max="maxValue" v-model="setRealResult" hidden>
    <div class="slider-result" ref="result" :style="setResult"></div>
    <div class="slider-control" ref="control" :style="setPosition"></div>
    <div class="slider-label" :data-start="minValue" :data-end="maxValue">
    </div>
  </div>
</template>

<script>
const isTouchDevice = (navigator.maxTouchPoints || 'ontouchstart' in document.documentElement);
let startEvent = 'mousedown';
let moveEvent = 'mousemove';
let endEvent = 'mouseup';

if (isTouchDevice) {
  startEvent = 'touchstart';
  moveEvent = 'touchmove';
  endEvent = 'touchend';
}

export default {
  name: 'SliderControl',
  data() {
    return {
      container: 0,
      result: null,
      resultValue: 0,
      initX: 0,
      initW: 0,
      inputValue: 0,
    };
  },
  props: {
    minValue: {
      type: Number,
      default: 0,
    },
    maxValue: {
      type: Number,
      default: 100,
    },
    value: {
      type: Number,
    },
  },
  computed: {
    setPosition() {
      return { left: `${this.resultValue}px` };
    },
    setResult() {
      return { width: `${this.resultValue}px` };
    },
    setPercent() {
      return ((this.resultValue / this.container) * 100);
    },
    setRealResult() {
      const valueData = (((this.maxValue - this.minValue) / 100) * this.setPercent + this.minValue);
      this.$emit('update', valueData);
      return valueData;
    },
  },
  mounted() {
    this.container = this.$refs.slider.clientWidth;
    this.resultValue = this.initRealValue(this.value);
    if (isTouchDevice) {
      this.$refs.slider.addEventListener(startEvent, this.sliderDown);
    }
  },
  methods: {
    sliderDown({ target: control, pageX: initX }) {
      if (control.classList.contains('slider-control')) {
        this.result = control.previousSibling || this.$refs.result;
        this.initX = initX;
        this.initW = this.result.offsetWidth;
        document.addEventListener(moveEvent, this.changePos);
        document.addEventListener(endEvent, this.sliderUp);
      }
    },
    sliderUp() {
      document.removeEventListener(moveEvent, this.changePos);
      document.removeEventListener(endEvent, this.sliderUp);
    },
    changePos({ pageX }) {
      const distance = pageX - this.initX;
      const result = this.initW + distance;
      if (result <= 0) {
        this.resultValue = 0;
      } else if (result >= this.container) {
        this.resultValue = this.container;
      } else {
        this.resultValue = result;
      }
    },
    initRealValue(value) {
      const percent = ((value - this.minValue) / (this.maxValue - this.minValue)) * 100;
      return this.container * (percent / 100);
    },
  },
};

</script>

<style lang="scss" scoped>
.slider-controller {
  position: relative;
  width: 100%;
  height: 1px;
  background-color: #0a0a0a;
  .slider-result {
    position: absolute;
    height: 100%;
    //background-color: #FF9F64;
  }
  .slider-control {
    cursor: grab;
    outline: 0;
    position: absolute;
    width: 16px;
    height: 16px;
    border: 1px solid #0a0a0a;
    border-radius: 50%;
    background-color: #FF9F64;
    top: 50%;
    transform: translate(-50%, -50%);
  }
  .slider-label {
    position: absolute;
    top: 100%;
    width: 100%;
    margin-top: 20px;
    font-size: 18px;
    font-weight: 400;
    line-height: 1.5;
    &:before {
      content: attr(data-start);
      position: absolute;
      left: 0;
      transform: translateX(-50%);
    }
    &:after {
      content: attr(data-end);
      position: absolute;
      right: 0;
      transform: translateX(50%);
    }
  }
}
</style>
